import Particle from "../../../../common/particle/v2";

import bannerThumb1 from "../../../../assets/images/octopuses/Oops.png";
import bannerThumb2 from "../../../../assets/images/octopuses/card-rigt.png";
import bannerThumb3 from "../../../../assets/images/octopuses/card-left.png";
// import bannerThumb1 from "../../../../assets/images/banner/Item1.png";
// import bannerThumb2 from "../../../../assets/images/banner/Item2.png";
// import bannerThumb3 from "../../../../assets/images/banner/Item3.png";
import NotFoundStyleWrapper from "./NotFound.style";


const NotFoundBanner = () => {

 

  return (
    <NotFoundStyleWrapper className="bithu_v3_baner_sect" id="home">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
          {/* <div className="col-lg-12"> */}
           
              {/* </div> */}
            <div className="banner-image-area3">
              {/* particles component */}
              <Particle />
              {/* <img
                className="banner-image banner-image1"
                src={bannerThumb1}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "500px"}}
              /> */}
              <img
                className="banner-image banner-image2"
                src={bannerThumb1}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "300px"}}
              />
              {/* <img
                className="banner-image banner-image3"
                src={bannerThumb3}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "300px"}}
              /> */}
            </div>
            <div className="banner-conent3">
              <div className="banner-title text-uppercase">
                <h1>The Page you are Looking for is not found</h1>
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </NotFoundStyleWrapper>
  );
};

export default NotFoundBanner;
